import { Component, OnInit, Inject } from '@angular/core';
import { FormControl} from '@angular/forms';
import {DialogService} from '@rbaip/ui-component';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {AssetPackageDto} from '../../shared/domain/asset-package';
import {ItemSummaryAssetControlGroupService} from '../../shared/asset-package/item-summary-asset-control-group.service';

@Component({
  selector: 'lib-item-summary-merge-package',
  templateUrl: './merge-package.component.html',
  styleUrls: ['./merge-package.component.scss']
})
export class MergePackageComponent implements OnInit {

  assetControlGroupList = [] as any;
  numberOfSearchResults: number;
  searchParam: FormControl = new FormControl();
  selectedMasterACG: AssetPackageDto;
  isSuccessfullyMergePackage: boolean;
  orphanACGId: number;

  constructor(@Inject(MAT_DIALOG_DATA)  private data: any,
              private dialogRef: MatDialogRef<MergePackageComponent>,
              private dialogService: DialogService,
              private assetControlGroupService: ItemSummaryAssetControlGroupService) {
    this.orphanACGId = this.data.acg;
    this.loadAssetPackageForAutoComplete();
  }

  ngOnInit() {
    this.searchParam.valueChanges.subscribe(
      term => {
        if (term != null && (term === '' || term.length > 2)) {
          this.assetControlGroupService.loadAssetControlGroupsForAutoComplete(term).subscribe(
            data => {
              this.assetControlGroupList = data as any[];
            });
        }
      });
  }

  private loadAssetPackageForAutoComplete() {
       this.assetControlGroupList = [];
       this.assetControlGroupService.loadAssetControlGroupsForAutoComplete(this.searchParam.value).subscribe(assetControlGroupList => {
         for (const acg of assetControlGroupList) {
           acg.displayName =   '<br>' + acg.assetPackageName + '<br>' + (!!acg.salesHubContractId ? 'Ct: ' + acg.salesHubContractId : '') + (!!acg.salesHubOpportunityId ? 'Opp: ' + acg.salesHubOpportunityId : '');
           this.assetControlGroupList.push(acg);
         }
         this.numberOfSearchResults = this.assetControlGroupList.length;
     });
   }

  displayFn(assetControlGroup: AssetPackageDto) {
    if (assetControlGroup) { return assetControlGroup.assetPackageName; }
  }

  mergeAssetPackage() {
    this.dialogService.showProgress();
    this.selectedMasterACG = this.searchParam.value;
    const masterACGId = this.selectedMasterACG ? this.selectedMasterACG.acgId : null;
    this.assetControlGroupService.mergePackage(masterACGId, this.orphanACGId).subscribe(() => {
      this.dialogService.showMessage('Successfully merged packages!');
      this.isSuccessfullyMergePackage = true;
      this.dialogService.hideProgress();
      this.closeSuccess();
      this.redirectPackageSummaryPage(masterACGId);
    }, error => {
      this.dialogService.hideProgress();
      this.dialogService.showMessage(error.toString());
    });
  }

  closeSuccess() {
    this.dialogRef.close();
  }

  redirectPackageSummaryPage(assetControlGroupId: number) {
    setTimeout(() => {
      window.location.href = `/asset-management-portal/#/opportunity/asset-packages/${assetControlGroupId}/summary`;
    });
  }
}
